export default "__VITE_ASSET__f5c0c205__"